<div class="dialog-container p-3" style="font-size: 0.88rem;">
  
  <!-- Encabezado del Modal de Edición -->
  <div class="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
    <h2 mat-dialog-title class="h5 m-0 fw-bold text-dark">✏️ Editar Ficha Técnica de Unidad</h2>
    <span class="badge bg-success font-monospace p-2">Unidad ID: {{ data.id }}</span>
  </div>

  <mat-dialog-content class="mat-typography">
    <form [formGroup]="unidadForm">
      
      <!-- SECCIÓN 1: VÍNCULO DE PROPIEDAD (MÁXIMO ESPACIO Y RUTA LOGÍSTICA CORRECTA) -->
      <div class="card bg-light mb-3 border-0 shadow-sm">
        <div class="card-body">
          <div class="grid-tecnica">
            
            <!-- 🌟 CORRECCIÓN: Ampliado a col-6 para dar total soltura al texto -->
            <div class="col-6">
              <div class="form-floating">
                <!-- 🌟 CORRECCIÓN: Enlazamos a la variable síncrona que busca el nombre en el catálogo -->
                <input type="text" class="form-control bg-white fw-semibold text-secondary" id="editCustomerName" 
                      [value]="nombreClienteResuelto" [disabled]="true">
                <label for="editCustomerName">Cliente Asociado</label>
              </div>
            </div>

            <!-- 🌟 CORRECCIÓN: Ampliado a col-6 para que el AN8 no se corte en absoluto -->
            <div class="col-6">
              <div class="form-floating">
                <input type="text" class="form-control bg-white fw-bold text-primary" id="editAn8Owner" 
                       [value]="$any(unidadForm.get('propietario.an8')).value || $any(data.propietario)?.an8 || ''" [disabled]="true">
                <label for="editAn8Owner">AN8 Corporativo</label>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- SECCIÓN 2: DATOS DE IDENTIFICACIÓN VEHICULAR (REJILLA DISTRIBUIDA HORIZONTALMENTE) -->
      <div class="card mb-3 border-0 shadow-sm">
        <div class="card-body p-2">
          
          <!-- Bloque A: Identidad Esencial (4 columnas perfectamente legibles) -->
		  <!-- Bloque A: Identidad Esencial (Convertidos a Selectores Dinámicos con descripciones UDC) -->
          <div class="grid-tecnica mb-3">
            
            <div class="col-3">
              <div class="form-floating">
                <!-- Select de marca conectado al escuchador en caliente -->
                <select class="form-select" id="editMarca" formControlName="marca" (change)="onMarcaSeleccionada($event)">
                  <option value="">-- Seleccione Marca --</option>
                  <option *ngFor="let m of marcas" [value]="m.keyRef">{{ m.description }}</option>
                </select>
                <label for="editMarca">Marca *</label>
              </div>
            </div>
            
            <div class="col-3">
              <div class="form-floating">
                <!-- Select de submarca que ahora resolverá el código por su descripción correspondiente -->
                <select class="form-select" id="editSubmarca" formControlName="submarca">
                  <option value="">-- Elige Submarca --</option>
                  <option *ngFor="let sm of submarcas" [value]="sm.keyRef">
                    {{ sm.description }}
                  </option>
                </select>
                <label for="editSubmarca">Submarca *</label>
              </div>
            </div>

            <!-- 🚀 SELECTOR DESPLEGABLE DE MODELO SIMÉTRICO AL ALTA -->
            <div class="col-3">
              <div class="form-floating">
                <select class="form-select" id="editModelo" formControlName="modelo"
                        [ngClass]="{'is-invalid': unidadForm.get('modelo')?.touched && unidadForm.get('modelo')?.invalid}">
                  <option value="">-- Elige Modelo --</option>
                  <option *ngFor="let anio of listaAnios" [value]="anio">{{ anio }}</option>
                </select>
                <label for="editModelo">Modelo (Versión) *</label>
              </div>
            </div>

            <!-- 🚀 SELECTOR DESPLEGABLE DE AÑO FABRICACIÓN SIMÉTRICO AL ALTA -->
            <div class="col-3">
              <div class="form-floating">
                <select class="form-select" id="editAnioFab" formControlName="aniofabricacion"
                        [ngClass]="{'is-invalid': unidadForm.get('aniofabricacion')?.touched && unidadForm.get('aniofabricacion')?.invalid}">
                  <option value="">-- Elige Año Fab. --</option>
                  <option *ngFor="let anio of listaAnios" [value]="anio">{{ anio }}</option>
                </select>
                <label for="editAnioFab">Año Fabricación *</label>
              </div>
            </div>
          </div>

          <!-- Bloque B: Control, Combustible y Servicio -->
          <div class="grid-tecnica mb-3">
            <div class="col-3">
              <div class="form-floating">
                <input type="text" class="form-control text-uppercase font-monospace fw-bold" id="placas" formControlName="placas" placeholder="Placas"
                appUppercase                                            
                [ngClass]="{'is-invalid': unidadForm.get('placas')?.touched && unidadForm.get('placas')?.invalid}">
                <label for="placas">Placas *</label>
                <div class="invalid-feedback">Las placas son requeridas.</div>
              </div>
            </div>

            <div class="col-3">
              <div class="form-floating">
                <input type="text" class="form-control text-uppercase" id="tcirculacion" formControlName="tcirculacion" placeholder="Tarjeta"
                appUppercase                                           
                [ngClass]="{'is-invalid': unidadForm.get('tcirculacion')?.touched && unidadForm.get('tcirculacion')?.invalid}">
                <label for="tcirculacion">Tarjeta Circulación</label>
                <div class="invalid-feedback">La tarjeta de circulación es requerida.</div>
              </div>
            </div>

            <div class="col-3">
              <div class="form-floating">
                <select class="form-select" id="editCombustible" formControlName="tipocombustible">
                  <option *ngFor="let comb of tiposCombustible" [value]="comb">{{ comb }}</option>
                </select>
                <label for="editCombustible">Combustible *</label>
              </div>
            </div>

            <div class="col-3">
              <div class="form-floating">
                <select class="form-select" id="editServicio" formControlName="tiposervicio">
                  <option *ngFor="let serv of tiposServicio" [value]="serv">{{ serv }}</option>
                </select>
                <label for="editServicio">Tipo de Servicio *</label>
              </div>
            </div>
          </div>

          <!-- Bloque C: Identificadores Técnicos Largos y Estatus -->
          <div class="grid-tecnica">
            <div class="col-4">
              <div class="form-floating">
                <input type="text" class="form-control font-monospace text-uppercase" id="numerovin" formControlName="numerovin" placeholder="VIN"
                appUppercase                
                [ngClass]="{'is-invalid': unidadForm.get('numerovin')?.touched && unidadForm.get('numerovin')?.invalid}">
                <label for="numerovin">Número VIN (Chasis)</label>
                <div class="invalid-feedback">El número VIN es obligatorio.</div>
              </div>
            </div>

            <div class="col-4">
              <div class="form-floating">
                <input type="text" class="form-control font-monospace text-uppercase" id="numeromotor" formControlName="numeromotor" placeholder="Motor"
                appUppercase                                     
                [ngClass]="{'is-invalid': unidadForm.get('numeromotor')?.touched && unidadForm.get('numeromotor')?.invalid}">
                <label for="numeromotor">Número de Motor</label>
                <div class="invalid-feedback">El número de motor es obligatorio.</div>
              </div>
            </div>

            <div class="col-2">
              <div class="form-floating">
                <select class="form-select" id="editColor" formControlName="color">
                  <option *ngFor="let col of coloresUnidad" [value]="col">{{ col }}</option>
                </select>
                <label for="editColor">Color *</label>
              </div>
            </div>

            <div class="col-2">
              <div class="form-floating">
                <select class="form-select fw-bold text-success" id="editStatus" formControlName="status">
                  <option *ngFor="let est of estatusUnidad" [value]="est">{{ est }}</option>
                </select>
                <label for="editStatus">Estatus *</label>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- CAMPOS DE AUDITORÍA OCULTOS (Mantenidos de forma interna en memoria) -->
      <div class="d-none">
        <input type="number" formControlName="id">
        <input type="text" formControlName="fechaalta">
        <input type="text" formControlName="fechabaja">
      </div>

    </form>
  </mat-dialog-content>

  <!-- Botones de Acción inferiores de Angular Material -->
  <mat-dialog-actions class="d-flex justify-content-end gap-2 border-top pt-2 mt-2">
    <button mat-button class="btn btn-sm btn-outline-secondary px-4 m-0" (click)="onCancel()">
      Cancelar
    </button>
    <button mat-raised-button class="btn btn-sm text-white px-4 m-0 shadow-sm" 
            (click)="onSave()" 
            [disabled]="unidadForm.invalid"
            style="background-color: #198754; font-weight: 500;"
            [ngClass]="{'opacity-50': unidadForm.invalid}">
      Guardar Vehículo
    </button>
  </mat-dialog-actions>

</div>

